<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-head">Contents</p>
<p class="toc-chapter" id="chap-1"><a href="#/Bec_chap1">Beginning</a></p>
<p class="toc-chapter" id="chap-2"><a href="#/Bec_chap2">Casualties</a></p>
<p class="toc-chapter" id="chap-3"><a href="#/Bec_chap3">Refugees</a></p>
<p class="toc-chapter" id="chap-4"><a href="#/Bec_chap4">The Boy</a></p>
<p class="toc-chapter" id="chap-5"><a href="#/Bec_chap5">The River</a></p>
<p class="toc-chapter" id="chap-6"><a href="#/Bec_chap6">The Stones</a></p>
<p class="toc-chapter" id="chap-7"><a href="#/Bec_chap7">The Crannog</a></p>
<p class="toc-chapter" id="chap-8"><a href="#/Bec_chap8">Drust</a></p>
<p class="toc-chapter" id="chap-9"><a href="#/Bec_chap9">Potential</a></p>
<p class="toc-chapter" id="chap-10"><a href="#/Bec_chap10">An Uninvited Guest</a></p>
<p class="toc-chapter" id="chap-11"><a href="#/Bec_chap11">Children of The Dark</a></p>
<p class="toc-chapter" id="chap-12"><a href="#/Bec_chap12">Family</a></p>
<p class="toc-chapter" id="chap-13"><a href="#/Bec_chap13">The Source</a></p>
<p class="toc-chapter" id="chap-14"><a href="#/Bec_chap14">The Emigrants</a></p>
<p class="toc-chapter" id="chap-15"><a href="#/Bec_chap15">The Geis</a></p>
<p class="toc-chapter" id="chap-16"><a href="#/Bec_chap16">Old Creatures</a></p>
<p class="toc-chapter" id="chap-17"><a href="#/Bec_chap17">Taming The Wild</a></p>
<p class="toc-chapter" id="chap-18"><a href="#/Bec_chap18">The Final Day</a></p>
<p class="toc-chapter" id="chap-19"><a href="#/Bec_chap19">The World Beneath</a></p>
<p class="toc-chapter" id="chap-20"><a href="#/Bec_chap20">The Sacrifice</a></p>
<p class="toc-chapter" id="chap-21"><a href="#/Bec_chap21">Escape</a></p>
<p class="toc-chapter" id="chap-22"><a href="#/Bec_chap22">Full Circle</a></p>
<p class="toc-chapter" id="teas-2"><a href="#/Bec_teas2">A Preview of "BLOOD BEAST"</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Bec_toc.vue?0c534172